'use client'
import useModal from '@/shared/hooks/useModal'
import { SearchIcon } from '@/shared/Icons'
import React from 'react'
import SearchModalBox from '../../search'

export default function SearchWidget(props: React.HTMLAttributes<HTMLDivElement>) {
  const { isOpen, setIsOpen, onClose } = useModal()
  return (
    <>
      <div
        {...props}
        className={`bg-footerBg rounded-xl border border-tabBorder p-4 w-full ${
          props.className || ''
        }`}
      >
        <p className="text-base font-medium leading-5 text-center">What are you looking for?</p>
        <div className="rounded-xl mt-3 flex items-center relative">
          <button
            onClick={() => setIsOpen(true)}
            className={
              'w-full flex items-center justify-center py-2 pl-3 text-xs font-normal bg-[#F1F1EE] dark:bg-cardBg border border-[#EBECED] dark:border-borderStroke shadow-none rounded-lg dark:text-[#4A4A4A] text-[#707070]'
            }
          >
            <SearchIcon className="h-4 w-4" />
            <span className="pl-1">Player, Series, Teams & more</span>
          </button>
        </div>
      </div>

      {isOpen && <SearchModalBox isOpen={isOpen} onClose={onClose} />}
    </>
  )
}
